/**
 * Contact / practice metadata. One source of truth — both Footer and
 * the contact CTA pull from here.
 */
export const practice = {
  name: 'Maxime Duisterhof',
  title: 'GZ-psycholoog',
  email: 'info@psycholoogmaxime.com',
  whatsappUrl: 'https://wa.me/', // TODO: fill in real number when available
  city: 'Amsterdam',
  kvk: '82170347',
};

export const navLinks = [
  { href: '#over', label: 'Over mij' },
  { href: '#behandeling', label: 'Behandeling' },
  { href: '#tarieven', label: 'Tarieven' },
  { href: '#contact', label: 'Contact' },
];
